<template>
  <div v-bind="$attrs">
    <div 
      :class="dropdownClass"
      class="dropdown">

      <div class="dropdown-trigger">
        <div 
          :class="inputClass"
          class="control has-icons-left has-icons-right">
          <input
            ref="input"
            class="input"
            :class="inputTextClass"
            :required="required"
            :value="searchStr"
            @focus="focused = true"
            @blur="focused = false"
            @input="debounceSearch"
            @click="selectText()"
            :disabled="disabled"
            :placeholder="placeholder">
          <span class="icon is-small is-left">
            <i class="fas fa-search"></i>
          </span>
          <span
            v-if="searchStr != null"
            @click="clear()" 
            class="icon is-small is-right is-clickable">
            <i class="fas fa-times"></i>
          </span>
        </div>
      </div>

      <div 
        v-if="hint || items.length > 0" 
        class="dropdown-menu" 
        role="menu">
        <div class="dropdown-content">
          <span 
            v-if="items.length == 0 && hint" 
            class="has-text-grey dropdown-item">
            {{ hint }}
          </span>
          <a 
            v-else
            v-for="item in items"
            :key="itemValue ? item[itemValue] : item"
            @mousedown="select(item)"
            class="dropdown-item">
            {{ itemText ? isFunction(itemText) ? itemText(item) : item[itemText] : item }}
          </a>
        </div>
      </div>
      
    </div>

    <div class="level" v-if="hasError">
      <div class="help has-text-danger pl-1">
        <div 
          v-for="(error, i) in errors"
          :key="i">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import validatable from '@/mixins/validatable'
import helpers from '@/helpers'

export default {
  props: {
    value: {
      type: [Number, String, Object],
    },
    searchInput: {
      type: [String, Number]
    },
    hint: {
      type: [String, Number]
    },
    isFullwidth: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: [String, Number],
      default: 'Search'
    },
    required: {
      type: Boolean
    },
    items: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: [String, Function]
    },
    itemValue: {
      type: [String, Function]
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  mixins: [validatable],
  data() {
    return {
      timeout: null,
      searchStr: null,
      focused: false,
      isFunction: helpers.isFunction
    }
  },
  computed: {
    dropdownClass() {
      return {
        'is-fullwidth': this.isFullwidth,
        'is-active': this.focused
      }
    },
    inputClass({ loading }) {
      return {
        'is-loading': loading
      }
    },
    inputTextClass({ hasError }) {
      return {
        'is-danger': hasError
      }
    }
  },
  watch: {
    searchInput(v) {
      if (v != this.searchStr) {
        this.searchStr = v;
      }
    }
  },
  created() {
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      if (this.searchInput) {
        this.searchStr = this.searchInput;
      }
    },
    debounceSearch(event) {
      this.searchStr = event.target.value;
      this.$emit('update:searchInput', event.target.value);

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit('search', event.target.value)
      }, 500)
    },
    select(item) {
      const { itemText, itemValue } = this;
      this.searchStr = itemText ? this.isFunction(itemText) ? itemText(item) : item[itemText] : item;
      let v = itemValue ? item[itemValue] : item;
      this.$emit('update:searchInput', this.searchStr);
      this.$emit('input', v);
      this.$emit('select', item);
      this.validate(v);
    },
    clear() {
      this.searchStr = null;
      this.$emit('update:searchInput', null);
      this.$emit('input', null);
      this.$emit('select', null);
      this.$emit('clear', true);
      this.validate(null);
    },
    selectText() {
      this.$refs.input.select();
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown.is-fullwidth {
  width: 100% !important;
  .dropdown-trigger {
    width: 100%;
  }
}

.is-clickable {
  cursor: pointer;
  pointer-events: initial !important;
}
</style>
